import React from 'react';
import { get } from 'lodash';
import {
  RegisterOptions,
  UseFormRegister,
  Path,
  DeepMap,
  FieldError,
  FieldValues,
} from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import InputDate, { InputDateProps } from '../input-date/InputDate';
import { FormErrorMessage } from '../form-error-message/FormErrorMessage';

export type FormInputDateProps<TFormValues extends FieldValues> = {
  name: Path<TFormValues>;
  rules?: RegisterOptions;
  register?: UseFormRegister<TFormValues>;
  errors?: Partial<DeepMap<TFormValues, FieldError>>;
} & Omit<InputDateProps, 'name'>;

const FormInputDate = <TFormValues extends Record<string, unknown>>({
  name,
  register,
  rules,
  errors,
  ...props
}: FormInputDateProps<TFormValues>): JSX.Element => {
  const errorMessages = get(errors, name)?.message;
  const hasError = !!(errors && errorMessages);

  return (
    <div className='form-field-container' aria-live='polite'>
      <InputDate
        name={name}
        aria-invalid={hasError}
        {...props}
        {...(register && register(name, rules))}
      />
      <ErrorMessage
        errors={errors}
        name={name as any}
        render={({ message }) => <FormErrorMessage>{message}</FormErrorMessage>}
      />
    </div>
  );
};

export default FormInputDate;
